/**
 * 【KYMW1600】画像情報更新要求VO
 *
 */
export class UpdateImageInfoModel {
  public imageId: string;                       // 画像ID
  public startOrderCode: string;                // 使用開始受注コード
  public endOrderCode: string;                  // 使用終了受注コード
  public processInstruct: string;               // 加工指示
  public remarks: string;                       // 備考
  public cookingExPublish: string;              // 調理例掲載区分
  public priority: string;                      // 優先度
  public cookingDiv: string;                    // 料理分類
  public cookingName: string;                   // 料理名
  public materialName: string;                  // 材料名
  public keyWord: string;                       // キーワード
  public eventId: string;                       // 催事・季節
  public photoContentsDiv: string;              // 撮影内容区分
  public photoInstructContents: string;         // 撮影指示内容
  public photoSchedule: string;                 // 撮影予定日
  public photoStudioId: string;                 // 撮影場所
  public textCaption: string;                   // 画像キャプション
}
